import(/* webpackMode: "eager", webpackExports: ["PageClient"] */ "/vercel/path0/app/client.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/index.css");
